import { render, staticRenderFns } from "./RequirementsAndConsiderations.vue?vue&type=template&id=3374631e"
import script from "./RequirementsAndConsiderations.vue?vue&type=script&lang=ts"
export * from "./RequirementsAndConsiderations.vue?vue&type=script&lang=ts"
import style0 from "./RequirementsAndConsiderations.vue?vue&type=style&index=0&id=3374631e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports